export const labels = Object.freeze({
  img: "Zdjęcie",
  name: "Nazwa",
  code: "Kod",
  price: "Cena",
  quantity: "Ilość sztuk"
})